angular
  .module('app')
  .filter('momentFromNow', function () {
    const fromNow = function (input) {
      return (moment().startOf('day') < input)
        ? moment(input).fromNow()
        : moment(input).calendar(null, {
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          nextWeek: '[Next] dddd',
          lastDay: '[Yesterday]',
          lastWeek: 'dddd',
          sameElse: 'DD/MM/YYYY',
        });
    };

    fromNow.$stateful = true;

    return fromNow;
  });
